import dayjs from 'dayjs'

export const contractStatusLabels = {
    created: 'Criado',
    accepted: 'Proposta aprovada',
    signed: 'Assinado',
    canceled: 'Cancelado',
}

export function contractStatusLabel(contract) {
    return contractStatusLabels[contract?.status] || 'Desconhecido'
}

export function isContractExpired(contract) {
    if (!contract || !contract.expires_at) {
        return false
    }
    return dayjs().isAfter(contract.expires_at)
}

// Legacy contracts created before the `status` field existed have a null
// status, which the platform treats as signed (see contracts/getAll queries).
export function isContractSigned(contract) {
    return !!contract && (contract.status === 'signed' || contract.status == null)
}

// A contract is only valid when it is signed and not expired.
export function isContractValid(contract) {
    return isContractSigned(contract) && !isContractExpired(contract)
}

// Returns a badge descriptor for use with the `.label` component styles.
// `intent` maps to a `.label.<intent>` modifier (success/error/warning/info).
export function getContractValidity(contract) {
    if (!contract) {
        return { label: 'Sem contrato', intent: 'warning', valid: false }
    }
    if (contract.status === 'canceled') {
        return { label: 'Cancelado', intent: 'error', valid: false }
    }
    if (!isContractSigned(contract)) {
        return { label: 'Não assinado', intent: 'warning', valid: false }
    }
    if (isContractExpired(contract)) {
        return { label: 'Expirado', intent: 'error', valid: false }
    }
    return { label: 'Válido', intent: 'success', valid: true }
}
